import React from 'react'
import styled from 'styled-components'

import { colors, fontFamily } from "buoy-theme"

const Unavailable = styled.div`
  font-family: ${fontFamily};
  background-color: ${colors.secondary};
  font-weight: 300;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 50px;
  margin-top: 60px;
  @media only screen and (min-width : 601px) {
    margin-top: 80px;
  }
}
`

const UnavailablePage = () => (
  <div className="row">
    <div className='col-xs-12'>
      <Unavailable>
        We’re sorry, Buoy is currently experiencing unusually high traffic. Please try again in a few minutes.
      </Unavailable>
    </div>
  </div>
)

export {UnavailablePage as default}



// WEBPACK FOOTER //
// ./assets/common/components/Unavailable.js